var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',_vm._g({domProps:{"value":_vm.value}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }